// extracted by mini-css-extract-plugin
export var Cookie = "Cookie-module--Cookie--76grx";
export var Text = "Cookie-module--Text--U7OQS";
export var Buttons = "Cookie-module--Buttons--ZRbQn";
export var Accept = "Cookie-module--Accept--jcLSh";
export var Close = "Cookie-module--Close--jKL-M";
export var arrowLeft = "Cookie-module--arrowLeft--iCfmQ";
export var arrowRight = "Cookie-module--arrowRight--fsJrx";